export enum SponsorTypeEnum {
  SAFE = 'safe',
  BALANCED = 'balanced',
  RISKY = 'risky',
}